import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import api from '../services/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const accesoRestringidoStyles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' },
  card: { backgroundColor: 'white', padding: '2rem 3rem', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', textAlign: 'center', maxWidth: '500px' },
  icon: { fontSize: '4rem', display: 'block', marginBottom: '1rem' },
  message: { color: '#6b7280', marginBottom: '1.5rem', lineHeight: '1.6' },
  suggestion: { fontSize: '0.9rem', color: '#9ca3af', marginBottom: '2rem' },
  button: { backgroundColor: '#3b82f6', color: 'white', border: 'none', padding: '0.75rem 1.5rem', borderRadius: '8px', fontSize: '1rem', cursor: 'pointer' },
};

const Configuracion = () => {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [accesoDenegado, setAccesoDenegado] = useState(false);
  const [mensajeError, setMensajeError] = useState('');
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [guardandoPago, setGuardandoPago] = useState(false);
  const [estadoSuscripcion, setEstadoSuscripcion] = useState(null);
  const [pagoConfig, setPagoConfig] = useState({
    activo: false,
    anticipo_tipo: 'fijo',
    anticipo_valor: 0,
    banco: '',
    tipo_cuenta: 'ahorros',
    numero_cuenta: '',
    titular_cuenta: '',
    identificacion_titular: '',
    whatsapp_cobros: '',
    instrucciones_adicionales: '',
    payphone_activo: false,
    payphone_token: '',
  });
  const [config, setConfig] = useState({
    modo_agendamiento: 'semana_corrida',
    dias_anticipacion_max: 7,
    meses_anticipacion_max: null,
    requiere_confirmacion: false,
    permite_cancelacion: true,
    horas_minimas_cancelacion: 24,
    envia_recordatorio_email: true,
    envia_recordatorio_whatsapp: false,
    horas_antes_recordatorio: 24
  });

  useEffect(() => {
    if (authLoading) return;
    if (user?.tenant?.acceso_bloqueado === true) {
      setAccesoDenegado(true);
      setMensajeError('Tu suscripción está suspendida. Contacta al administrador.');
      setLoading(false);
      return;
    }
    if (user?.rol !== 'admin' && user?.puede_configurar === false) {
      setAccesoDenegado(true);
      setMensajeError('No tienes permisos para acceder a la configuración.');
      setLoading(false);
      return;
    }
    fetchConfiguracion();
  }, [authLoading]);

  const fetchConfiguracion = async () => {
    try {
      const [agendRes, pagoRes, estadoRes] = await Promise.all([
        api.get('/configuracion/agendamiento'),
        api.get('/pago-config'),
        api.get('/planes/estado'),
      ]);
      setConfig(agendRes.data);
      setPagoConfig({ ...pagoRes.data, activo: !!pagoRes.data.activo, payphone_activo: !!pagoRes.data.payphone_activo });
      setEstadoSuscripcion(estadoRes.data);
    } catch (error) {
      if (error.response?.status === 403) {
        setAccesoDenegado(true);
        setMensajeError(error.response.data.message || 'No tienes acceso a esta sección.');
      } else {
        toast.error('Error al cargar configuración');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setGuardando(true);
    try {
      await api.put('/configuracion/agendamiento', config);
      toast.success('Configuración guardada correctamente');
    } catch (error) {
      toast.error(error.response?.data?.error || 'Error al guardar configuración');
    } finally {
      setGuardando(false);
    }
  };

  const handleSavePago = async () => {
    if (pagoConfig.activo) {
      if (!pagoConfig.banco?.trim() || !pagoConfig.numero_cuenta?.trim() || !pagoConfig.titular_cuenta?.trim()) {
        toast.error('Completa banco, número de cuenta y titular para activar el cobro por transferencia');
        return;
      }
    }
    if (pagoConfig.payphone_activo && !pagoConfig.payphone_token?.trim()) {
      toast.error('Pega el Access Token de PayPhone para activar el pago con tarjeta');
      return;
    }
    setGuardandoPago(true);
    try {
      await api.put('/pago-config', pagoConfig);
      toast.success('Configuración de pagos guardada');
    } catch (error) {
      toast.error(error.response?.data?.error || 'Error al guardar');
    } finally {
      setGuardandoPago(false);
    }
  };

  // Estilos comunes
  const inputStyle = {
    border: '2px solid rgba(59, 130, 246, 0.3)',
    borderRadius: '8px',
    padding: '0.75rem',
    fontSize: '1rem',
    backgroundColor: '#fafafa',
    width: '100%',
    transition: 'all 0.2s'
  };

  if (accesoDenegado) {
    return (
      <Layout>
        <div style={accesoRestringidoStyles.container}>
          <div style={accesoRestringidoStyles.card}>
            <span style={accesoRestringidoStyles.icon}>🔒</span>
            <h2>Acceso Restringido</h2>
            <p style={accesoRestringidoStyles.message}>{mensajeError}</p>
            <p style={accesoRestringidoStyles.suggestion}>
              Si crees que esto es un error, contacta al administrador del sistema para revisar los detalles de tu plan.
            </p>
            <button
              style={accesoRestringidoStyles.button}
              onClick={() => navigate('/')}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
            >
              Volver al Dashboard
            </button>
          </div>
        </div>
      </Layout>
    );
  }

  if (loading) {
    return (
      <Layout>
        <div className="text-center" style={{ padding: '3rem' }}>
          <div className="loading"></div>
          <p style={{ marginTop: '1rem', color: 'var(--text-secondary)' }}>Cargando configuración...</p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="page-header">
        <div>
          <h2>⚙️ Configuración de Agendamiento</h2>
          <p className="page-subtitle">Personaliza cómo tus clientes pueden agendar y gestionar sus citas</p>
        </div>
        <button 
          className="btn btn-primary" 
          onClick={handleSubmit}
          disabled={guardando}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.75rem 1.5rem',
            fontSize: '1rem'
          }}
        >
          {guardando ? (
            <>
              <span className="loading" style={{ width: '1rem', height: '1rem' }}></span>
              Guardando...
            </>
          ) : (
            <>
              💾 Guardar Configuración
            </>
          )}
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        {/* Ventana de Agendamiento */}
        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <div className="card-header" style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '0.75rem',
            marginBottom: '1.5rem',
            paddingBottom: '1rem',
            borderBottom: '2px solid #e5e7eb'
          }}>
            <span style={{ fontSize: '1.8rem' }}>📅</span>
            <div>
              <h3 className="card-title" style={{ margin: 0 }}>Ventana de Agendamiento</h3>
              <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem', margin: '0.25rem 0 0 0' }}>
                Define cuánto tiempo con anticipación pueden agendar tus clientes
              </p>
            </div>
          </div>

          <div style={{ display: 'grid', gap: '1rem' }}>
            {/* Opciones de modo de agendamiento */}
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
              gap: '1rem',
              marginBottom: '1rem'
            }}>
              {/* Días Fijos */}
              <div 
                onClick={() => setConfig({...config, modo_agendamiento: 'dias_fijos'})}
                style={{
                  border: `2px solid ${config.modo_agendamiento === 'dias_fijos' ? '#3b82f6' : '#e5e7eb'}`,
                  borderRadius: '16px',
                  padding: '1.25rem',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  backgroundColor: config.modo_agendamiento === 'dias_fijos' ? 'rgba(59, 130, 246, 0.05)' : 'white'
                }}
                onMouseEnter={(e) => {
                  if (config.modo_agendamiento !== 'dias_fijos') {
                    e.currentTarget.style.borderColor = '#93c5fd';
                    e.currentTarget.style.backgroundColor = '#f9fafb';
                  }
                }}
                onMouseLeave={(e) => {
                  if (config.modo_agendamiento !== 'dias_fijos') {
                    e.currentTarget.style.borderColor = '#e5e7eb';
                    e.currentTarget.style.backgroundColor = 'white';
                  }
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
                  <span style={{ fontSize: '1.5rem' }}>📆</span>
                  {config.modo_agendamiento === 'dias_fijos' && (
                    <span style={{ color: '#3b82f6', fontSize: '1.2rem' }}>✓</span>
                  )}
                </div>
                <h4 style={{ marginBottom: '0.5rem', fontSize: '1.1rem' }}>Días Fijos</h4>
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem', marginBottom: '1rem' }}>
                  Los clientes pueden agendar X días fijos adelante
                </p>
                {config.modo_agendamiento === 'dias_fijos' && (
                  <div style={{ marginTop: '0.5rem' }}>
                    <label style={{ fontSize: '0.75rem', color: '#6b7280', marginBottom: '0.25rem', display: 'block' }}>
                      Días de anticipación
                    </label>
                    <input
                      type="number"
                      className="form-input"
                      value={config.dias_anticipacion_max}
                      onChange={(e) => setConfig({...config, dias_anticipacion_max: parseInt(e.target.value)})}
                      min="1"
                      max="90"
                      style={{
                        ...inputStyle,
                        padding: '0.5rem 0.75rem',
                        fontSize: '0.9rem'
                      }}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <small style={{ color: 'var(--text-secondary)', fontSize: '0.7rem', display: 'block', marginTop: '0.25rem' }}>
                      Ejemplo: 15 días = pueden agendar desde hoy hasta dentro de 15 días
                    </small>
                  </div>
                )}
              </div>

              {/* Semana Corrida (comentado por ahora) */}
              {/* <div 
                onClick={() => setConfig({...config, modo_agendamiento: 'semana_corrida'})}
                style={{
                  border: `2px solid ${config.modo_agendamiento === 'semana_corrida' ? '#3b82f6' : '#e5e7eb'}`,
                  borderRadius: '16px',
                  padding: '1.25rem',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  backgroundColor: config.modo_agendamiento === 'semana_corrida' ? 'rgba(59, 130, 246, 0.05)' : 'white'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
                  <span style={{ fontSize: '1.5rem' }}>📅</span>
                  {config.modo_agendamiento === 'semana_corrida' && <span style={{ color: '#3b82f6', fontSize: '1.2rem' }}>✓</span>}
                </div>
                <h4 style={{ marginBottom: '0.5rem', fontSize: '1.1rem' }}>Semana Corrida</h4>
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem', marginBottom: '1rem' }}>
                  Los clientes pueden agendar hasta X días adelante
                </p>
                {config.modo_agendamiento === 'semana_corrida' && (
                  <div style={{ marginTop: '0.5rem' }}>
                    <label style={{ fontSize: '0.75rem', color: '#6b7280', marginBottom: '0.25rem', display: 'block' }}>Días de anticipación</label>
                    <input type="number" value={config.dias_anticipacion_max} onChange={(e) => setConfig({...config, dias_anticipacion_max: parseInt(e.target.value)})} min="1" max="30" style={{ ...inputStyle, padding: '0.5rem 0.75rem', fontSize: '0.9rem' }} onClick={(e) => e.stopPropagation()} />
                    <small style={{ color: 'var(--text-secondary)', fontSize: '0.7rem', display: 'block', marginTop: '0.25rem' }}>Por defecto: 7 días</small>
                  </div>
                )}
              </div> */}

              {/* Extendido (comentado por ahora) */}
            </div>
          </div>
        </div>

        {/* Confirmaciones y Cancelaciones */}
        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <div className="card-header" style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '0.75rem',
            marginBottom: '1.5rem',
            paddingBottom: '1rem',
            borderBottom: '2px solid #e5e7eb'
          }}>
            <span style={{ fontSize: '1.8rem' }}>🔔</span>
            <div>
              <h3 className="card-title" style={{ margin: 0 }}>Confirmaciones y Cancelaciones</h3>
              <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem', margin: '0.25rem 0 0 0' }}>
                Controla cómo se gestionan las citas y las cancelaciones
              </p>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: '1rem',
              padding: '1rem',
              backgroundColor: '#f9fafb',
              borderRadius: '12px'
            }}>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                  <span style={{ fontSize: '1.2rem' }}>✅</span>
                  <strong>Requiere confirmación del negocio</strong>
                </div>
                <small style={{ color: 'var(--text-secondary)' }}>
                  Si se activa, las citas quedarán pendientes hasta que las confirmes manualmente
                </small>
              </div>
              <label style={{ position: 'relative', display: 'inline-block' }}>
                <input
                  type="checkbox"
                  checked={config.requiere_confirmacion}
                  onChange={(e) => setConfig({...config, requiere_confirmacion: e.target.checked})}
                  style={{
                    width: '44px',
                    height: '24px',
                    appearance: 'none',
                    backgroundColor: config.requiere_confirmacion ? '#3b82f6' : '#e5e7eb',
                    borderRadius: '24px',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    position: 'relative'
                  }}
                />
                <span style={{
                  position: 'absolute',
                  top: '2px',
                  left: config.requiere_confirmacion ? '22px' : '2px',
                  width: '20px',
                  height: '20px',
                  backgroundColor: 'white',
                  borderRadius: '50%',
                  transition: 'left 0.2s',
                  pointerEvents: 'none'
                }} />
              </label>
            </div>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: '1rem',
              padding: '1rem',
              backgroundColor: '#f9fafb',
              borderRadius: '12px'
            }}>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                  <span style={{ fontSize: '1.2rem' }}>🗑️</span>
                  <strong>Permite que los clientes cancelen citas</strong>
                </div>
              </div>
              <label style={{ position: 'relative', display: 'inline-block' }}>
                <input
                  type="checkbox"
                  checked={config.permite_cancelacion}
                  onChange={(e) => setConfig({...config, permite_cancelacion: e.target.checked})}
                  style={{
                    width: '44px',
                    height: '24px',
                    appearance: 'none',
                    backgroundColor: config.permite_cancelacion ? '#3b82f6' : '#e5e7eb',
                    borderRadius: '24px',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    position: 'relative'
                  }}
                />
                <span style={{
                  position: 'absolute',
                  top: '2px',
                  left: config.permite_cancelacion ? '22px' : '2px',
                  width: '20px',
                  height: '20px',
                  backgroundColor: 'white',
                  borderRadius: '50%',
                  transition: 'left 0.2s',
                  pointerEvents: 'none'
                }} />
              </label>
            </div>

            {config.permite_cancelacion && (
              <div style={{ marginTop: '0.5rem' }}>
                <label className="form-label" style={{ fontWeight: '600', color: '#374151', marginBottom: '0.5rem', display: 'block' }}>
                  ⏰ Horas mínimas para cancelar
                </label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <input
                    type="number"
                    className="form-input"
                    value={config.horas_minimas_cancelacion}
                    onChange={(e) => setConfig({...config, horas_minimas_cancelacion: parseInt(e.target.value)})}
                    min="0"
                    max="72"
                    style={{ ...inputStyle, width: '120px' }}
                  />
                  <span style={{ color: 'var(--text-secondary)' }}>horas antes de la cita</span>
                </div>
                <small style={{ color: 'var(--text-secondary)', display: 'block', marginTop: '0.25rem' }}>
                  Ejemplo: 24 horas = el cliente debe cancelar al menos 24 horas antes de la cita
                </small>
              </div>
            )}
          </div>
        </div>

        {/* Recordatorios */}
        <div className="card" style={{ display: 'none' }}>
          <div className="card-header" style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '0.75rem',
            marginBottom: '1.5rem',
            paddingBottom: '1rem',
            borderBottom: '2px solid #e5e7eb'
          }}>
            <span style={{ fontSize: '1.8rem' }}>📧</span>
            <div>
              <h3 className="card-title" style={{ margin: 0 }}>Recordatorios</h3>
              <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem', margin: '0.25rem 0 0 0' }}>
                Configura cómo recordar a tus clientes sus citas
              </p>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: '1rem',
              padding: '1rem',
              backgroundColor: '#f9fafb',
              borderRadius: '12px'
            }}>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                  <span style={{ fontSize: '1.2rem' }}>✉️</span>
                  <strong>Recordatorios por Email</strong>
                </div>
              </div>
              <label style={{ position: 'relative', display: 'inline-block' }}>
                <input
                  type="checkbox"
                  checked={config.envia_recordatorio_email}
                  onChange={(e) => setConfig({...config, envia_recordatorio_email: e.target.checked})}
                  style={{
                    width: '44px',
                    height: '24px',
                    appearance: 'none',
                    backgroundColor: config.envia_recordatorio_email ? '#3b82f6' : '#e5e7eb',
                    borderRadius: '24px',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    position: 'relative'
                  }}
                />
                <span style={{
                  position: 'absolute',
                  top: '2px',
                  left: config.envia_recordatorio_email ? '22px' : '2px',
                  width: '20px',
                  height: '20px',
                  backgroundColor: 'white',
                  borderRadius: '50%',
                  transition: 'left 0.2s',
                  pointerEvents: 'none'
                }} />
              </label>
            </div>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: '1rem',
              padding: '1rem',
              backgroundColor: '#f9fafb',
              borderRadius: '12px'
            }}>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                  <span style={{ fontSize: '1.2rem' }}>💬</span>
                  <strong>Recordatorios por WhatsApp</strong>
                </div>
                <small style={{ color: 'var(--text-secondary)' }}>Requiere integración con WhatsApp Business API</small>
              </div>
              <label style={{ position: 'relative', display: 'inline-block' }}>
                <input
                  type="checkbox"
                  checked={config.envia_recordatorio_whatsapp}
                  onChange={(e) => setConfig({...config, envia_recordatorio_whatsapp: e.target.checked})}
                  style={{
                    width: '44px',
                    height: '24px',
                    appearance: 'none',
                    backgroundColor: config.envia_recordatorio_whatsapp ? '#3b82f6' : '#e5e7eb',
                    borderRadius: '24px',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    position: 'relative'
                  }}
                />
                <span style={{
                  position: 'absolute',
                  top: '2px',
                  left: config.envia_recordatorio_whatsapp ? '22px' : '2px',
                  width: '20px',
                  height: '20px',
                  backgroundColor: 'white',
                  borderRadius: '50%',
                  transition: 'left 0.2s',
                  pointerEvents: 'none'
                }} />
              </label>
            </div>

            {/* {(config.envia_recordatorio_email || config.envia_recordatorio_whatsapp) && (
              <div style={{ marginTop: '0.5rem' }}>
                <label className="form-label" style={{ fontWeight: '600', color: '#374151', marginBottom: '0.5rem', display: 'block' }}>
                  ⏰ Enviar recordatorio X horas antes
                </label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <input
                    type="number"
                    className="form-input"
                    value={config.horas_antes_recordatorio}
                    onChange={(e) => setConfig({...config, horas_antes_recordatorio: parseInt(e.target.value)})}
                    min="1"
                    max="72"
                    style={{ ...inputStyle, width: '120px' }}
                  />
                  <span style={{ color: 'var(--text-secondary)' }}>horas antes de la cita</span>
                </div>
                <small style={{ color: 'var(--text-secondary)', display: 'block', marginTop: '0.25rem' }}>
                  Ejemplo: 24 horas = el recordatorio se envía 1 día antes de la cita
                </small>
              </div>
            )} */}
          </div>
        </div>
      </form>

      {/* ── Cobros y anticipos ── */}
      <div className="card" style={{ marginTop: '1.5rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.5rem', paddingBottom: '1rem', borderBottom: '2px solid #e5e7eb' }}>
          <span style={{ fontSize: '1.8rem' }}>💳</span>
          <div>
            <h3 className="card-title" style={{ margin: 0 }}>Cobros y anticipos</h3>
            <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem', margin: '0.25rem 0 0 0' }}>
              Solicita un anticipo por transferencia al momento de la reserva online
            </p>
          </div>
        </div>

        {/* Toggle principal */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem', padding: '1rem', backgroundColor: '#f9fafb', borderRadius: '12px', marginBottom: '1.25rem' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
              <span style={{ fontSize: '1.2rem' }}>💰</span>
              <strong>Requerir anticipo al reservar</strong>
            </div>
            <small style={{ color: 'var(--text-secondary)' }}>
              La reserva quedará como "Pendiente de pago" hasta que confirmes el depósito
            </small>
          </div>
          <label style={{ position: 'relative', display: 'inline-block', flexShrink: 0 }}>
            <input
              type="checkbox"
              checked={!!pagoConfig.activo}
              onChange={e => setPagoConfig(p => ({ ...p, activo: e.target.checked }))}
              style={{ width: '44px', height: '24px', appearance: 'none', backgroundColor: pagoConfig.activo ? '#3b82f6' : '#e5e7eb', borderRadius: '24px', cursor: 'pointer', transition: 'all 0.2s' }}
            />
            <span style={{ position: 'absolute', top: '2px', left: pagoConfig.activo ? '22px' : '2px', width: '20px', height: '20px', backgroundColor: 'white', borderRadius: '50%', transition: 'left 0.2s', pointerEvents: 'none' }} />
          </label>
        </div>

        {pagoConfig.activo && (
          <div style={{ paddingTop: '0.75rem', borderTop: '1px solid #f3f4f6' }}>
            <p style={{ margin: '0 0 0.75rem', fontWeight: '600', fontSize: '0.9rem', color: '#374151' }}>Datos bancarios para depósito / transferencia</p>
            <div className="grid-responsive" style={{ gap: '0.75rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: '600', color: '#374151', marginBottom: '0.3rem' }}>Banco *</label>
                <input style={inputStyle} value={pagoConfig.banco} onChange={e => setPagoConfig(p => ({ ...p, banco: e.target.value }))} placeholder="Ej: Banco Pichincha" />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: '600', color: '#374151', marginBottom: '0.3rem' }}>Tipo de cuenta</label>
                <select style={inputStyle} value={pagoConfig.tipo_cuenta} onChange={e => setPagoConfig(p => ({ ...p, tipo_cuenta: e.target.value }))}>
                  <option value="ahorros">Ahorros</option>
                  <option value="corriente">Corriente</option>
                  <option value="monetaria">Monetaria</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: '600', color: '#374151', marginBottom: '0.3rem' }}>Número de cuenta *</label>
                <input style={inputStyle} value={pagoConfig.numero_cuenta} onChange={e => setPagoConfig(p => ({ ...p, numero_cuenta: e.target.value }))} placeholder="Ej: 2200123456" />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: '600', color: '#374151', marginBottom: '0.3rem' }}>Titular *</label>
                <input style={inputStyle} value={pagoConfig.titular_cuenta} onChange={e => setPagoConfig(p => ({ ...p, titular_cuenta: e.target.value }))} placeholder="Nombre completo del titular" />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: '600', color: '#374151', marginBottom: '0.3rem' }}>C.I / RUC del titular</label>
                <input style={inputStyle} value={pagoConfig.identificacion_titular} onChange={e => setPagoConfig(p => ({ ...p, identificacion_titular: e.target.value }))} placeholder="Ej: 1712345678" />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: '600', color: '#374151', marginBottom: '0.3rem' }}>WhatsApp para comprobantes</label>
                <input style={inputStyle} type="tel" value={pagoConfig.whatsapp_cobros} onChange={e => setPagoConfig(p => ({ ...p, whatsapp_cobros: e.target.value }))} placeholder="Ej: 0991234567" />
              </div>
            </div>
          </div>
        )}

        {/* PayPhone */}
        <div style={{ marginTop: '1.5rem', paddingTop: '1.25rem', borderTop: '2px solid #e5e7eb' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem', padding: '1rem', backgroundColor: '#f9fafb', borderRadius: '12px', marginBottom: pagoConfig.payphone_activo ? '1rem' : 0 }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.25rem' }}>
                <span style={{ fontSize: '1.3rem' }}>💳</span>
                <strong>Pago con tarjeta — PayPhone</strong>
                <span style={{ fontSize: '0.72rem', background: '#dbeafe', color: '#1e40af', padding: '0.15rem 0.5rem', borderRadius: '8px', fontWeight: '700' }}>ECUADOR</span>
              </div>
              <small style={{ color: 'var(--text-secondary)' }}>
                El cliente paga al momento de reservar con tarjeta de crédito/débito o billetera PayPhone
              </small>
            </div>
            <label style={{ position: 'relative', display: 'inline-block', flexShrink: 0 }}>
              <input
                type="checkbox"
                checked={!!pagoConfig.payphone_activo}
                onChange={e => setPagoConfig(p => ({ ...p, payphone_activo: e.target.checked }))}
                style={{ width: '44px', height: '24px', appearance: 'none', backgroundColor: pagoConfig.payphone_activo ? '#3b82f6' : '#e5e7eb', borderRadius: '24px', cursor: 'pointer', transition: 'all 0.2s' }}
              />
              <span style={{ position: 'absolute', top: '2px', left: pagoConfig.payphone_activo ? '22px' : '2px', width: '20px', height: '20px', backgroundColor: 'white', borderRadius: '50%', transition: 'left 0.2s', pointerEvents: 'none' }} />
            </label>
          </div>

          {!!pagoConfig.payphone_activo && (
            <div>
              <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '10px', padding: '0.75rem 1rem', marginBottom: '0.75rem', fontSize: '0.82rem', color: '#1e40af' }}>
                <strong>¿Cómo obtener el Token?</strong> Ingresa a tu cuenta PayPhone → <em>Configuración → Integración → Button API</em> → copia el <strong>Access Token</strong> de tu tienda.
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: '600', color: '#374151', marginBottom: '0.3rem' }}>Access Token de PayPhone *</label>
                <input
                  style={{ ...inputStyle, fontFamily: 'monospace', fontSize: '0.82rem' }}
                  type="password"
                  value={pagoConfig.payphone_token}
                  onChange={e => setPagoConfig(p => ({ ...p, payphone_token: e.target.value }))}
                  placeholder="Pega aquí tu token de PayPhone..."
                  autoComplete="off"
                />
                <small style={{ color: '#6b7280', display: 'block', marginTop: '0.3rem' }}>
                  El token se guarda cifrado y nunca se muestra al cliente.
                </small>
              </div>
              <div style={{ background: '#fef3c7', border: '1px solid #fcd34d', borderRadius: '8px', padding: '0.6rem 0.85rem', marginTop: '0.75rem', fontSize: '0.8rem', color: '#92400e' }}>
                💡 Con PayPhone activo, el cliente puede <strong>elegir</strong> entre pagar con tarjeta al reservar o pagar en el local. Si además tienes activo el anticipo por transferencia, se mostrarán ambas opciones.
              </div>
            </div>
          )}
        </div>

        <button
          className="btn btn-primary"
          onClick={handleSavePago}
          disabled={guardandoPago}
          style={{ marginTop: '1.25rem', opacity: guardandoPago ? 0.7 : 1 }}
        >
          {guardandoPago ? 'Guardando...' : '💾 Guardar configuración de pagos'}
        </button>
      </div>

      {/* ─── SECCIÓN: Mi Suscripción ─────────────────────────────────────────────── */}
      {estadoSuscripcion && (
        <div className="card" style={{ marginTop: '1.75rem' }}>
          <h3 style={{ marginTop: 0, marginBottom: '1.25rem', fontSize: '1rem', fontWeight: '700', color: '#374151' }}>
            💳 Mi suscripción
          </h3>

          <div className="grid-responsive" style={{ gap: '1.25rem', marginBottom: '1.5rem' }}>
            {/* Plan actual */}
            <div style={{ padding: '1rem', background: '#f0fdf4', borderRadius: '10px', border: '1px solid #86efac' }}>
              <div style={{ fontSize: '0.8rem', color: '#6b7280', marginBottom: '0.25rem' }}>Plan actual</div>
              <div style={{ fontSize: '1.3rem', fontWeight: '800', color: '#111827' }}>
                {estadoSuscripcion?.plan?.nombre || 'Cargando...'}
              </div>
              <div style={{ fontSize: '0.95rem', color: '#16a34a', marginTop: '0.5rem' }}>
                ${parseFloat(estadoSuscripcion?.plan?.precio || 0).toFixed(2)}/mes
              </div>
            </div>

            {/* Estado y vencimiento */}
            <div style={{ padding: '1rem', background: '#eff6ff', borderRadius: '10px', border: '1px solid #bfdbfe' }}>
              <div style={{ fontSize: '0.8rem', color: '#6b7280', marginBottom: '0.25rem' }}>Estado</div>
              <div style={{ fontSize: '1rem', fontWeight: '700', color: '#1d4ed8', marginBottom: '0.75rem' }}>
                ✅ {['activo','activa'].includes(estadoSuscripcion?.estado_suscripcion) ? 'Activo' : 'Inactivo'}
              </div>
              <div style={{ fontSize: '0.85rem', color: '#6b7280' }}>
                Vencimiento:{' '}
                <strong>
                  {estadoSuscripcion?.fecha_vencimiento
                    ? new Date(estadoSuscripcion.fecha_vencimiento).toLocaleDateString('es-EC', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })
                    : 'N/A'}
                </strong>
              </div>
              {estadoSuscripcion?.dias_vencimiento > 0 && (
                <div style={{ fontSize: '0.85rem', color: '#1d4ed8', marginTop: '0.5rem', fontWeight: '600' }}>
                  📅 {estadoSuscripcion.dias_vencimiento} días restantes
                </div>
              )}
            </div>
          </div>

          {/* Botones de acción */}
          <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
            <button
              onClick={() => navigate('/cambiar-plan')}
              style={{
                flex: '1 1 150px',
                padding: '0.75rem 1rem',
                background: '#3b82f6',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                fontWeight: '600',
                cursor: 'pointer',
                fontSize: '0.9rem',
              }}
            >
              📊 Cambiar plan
            </button>
            <button
              onClick={() => navigate('/suscripcion/pagar')}
              style={{
                flex: '1 1 150px',
                padding: '0.75rem 1rem',
                background: '#10b981',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                fontWeight: '600',
                cursor: 'pointer',
                fontSize: '0.9rem',
              }}
            >
              🔄 Renovar plan
            </button>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default Configuracion;